<template>
  <div class="modal fade" id="modal-trackingModalVisible" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Suivi du stock : {{selectedProduct?.productName}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table table-bordered text-center">
              <thead>
              <tr>
                <th>Date</th><th>Ref</th>
                <th colspan="3">Entrées</th>
                <th colspan="3">Sorties</th>
                <th colspan="3">Stock</th>
              </tr>
              <tr>
                <th></th><th></th>
                <th>Q</th><th>PU</th><th>MT</th>
                <th>Q</th><th>PU</th><th>MT</th>
                <th>Q</th><th>PU</th><th>MT</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(line, i) in movements" :key="i">
                <td>{{ line.date | dateFormat }}</td>
                <td>{{ line.ref }}</td>

                <td>{{ line.entryQ || '' }}</td>
                <td>{{ line.entryPu || '' }}</td>
                <td>{{ line.entryMt || '' }}</td>

                <td>{{ line.exitQ || '' }}</td>
                <td>{{ line.exitPu || '' }}</td>
                <td>{{ line.exitMt || '' }}</td>

                <td><strong>{{ line.stockQ }}</strong></td>
                <td>{{ line.stockPu }}</td>
                <td>{{ line.stockMt }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ModalGlobalStockReport",
    props: {
      product: Object,
      movements: Array
    },
    methods: {
      formatDate(dateStr) {
        const d = new Date(dateStr);
        return d.toLocaleString();
      }
    }
  };
</script>
